import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { PubReplicateService } from "@viewer/replication/service/pub-replicate.service";
import { PubDoc } from "libs/models/couch.models";
import { Store } from "@viewer/core";
import { PubDestroyService } from "@viewer/replication/service/pub-destroy.service";
import { HomeRoute } from "@viewer/home/models";

@Component({
  standalone: false,
  selector: "o-pub-destroy-modal",
  templateUrl: "pub-destroy-modal.component.html",
  styleUrls: ["./pub-destroy-modal.component.scss"]
})
export class PubDestroyModalComponent {
  public isDeleting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { pub: PubDoc },
    private store: Store,
    private dialogRef: MatDialogRef<PubDestroyModalComponent>,
    private router: Router,
    private pubDestroyService: PubDestroyService,
    private pubReplicateService: PubReplicateService
  ) {}

  public confirm(): Promise<boolean> {
    this.isDeleting = true;
    const pubToDelete = this.data.pub;

    // This is to deal with cases where we delete a pub partially replicated.
    this.pubReplicateService.resetProgress(pubToDelete);
    this.store.pubInfo = pubToDelete;
    // this for retrocompatibility: change isS1000D by partS1000D and taskS1000D
    if (this.store.pubInfo.isS1000D) {
      this.store.pubInfo.partS1000D = true;
      this.store.pubInfo.taskS1000D = true;
    }

    return this.pubDestroyService.destroyPub(pubToDelete.occurrenceCode).then(() => {
      this.dialogRef.close();
      // We make a dummy navigate to /online route before navigating again to /local to force page refresh
      return this.router
        .navigateByUrl(HomeRoute.ONLINE, { skipLocationChange: true })
        .then(() => this.router.navigate([HomeRoute.LOCAL]));
    });
  }
}
